/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { HousePlanListBusinessService } from '../../resources/house-plan-list-business.service';
import { HousePlanDetailsDialogComponent } from './house-plan-details-dialog.component';

export const housePlanDetailsDialogRoute = createDialogRoute({
  component: HousePlanDetailsDialogComponent,
  init: HousePlanListBusinessService,
});
